import {
    DomainInitPayload,
    MagicLinkInfo,
} from '@sxm-de/dev-kits/web-sdk/types';
import { logErrorFromMicroservicesSdk } from '@sxm-de/dev-kits/web-sdk/utils';

interface GenerateMagicLinkWithEmailAndPasswordFnPayload {
    email: string;
    password: string;
}

export type GenerateMagicLinkWithEmailAndPasswordFn = (
    payload: GenerateMagicLinkWithEmailAndPasswordFnPayload,
) => Promise<MagicLinkInfo>;

export function initGenerateMagicLinkWithEmailAndPasswordFn({
    dependencies,
}: DomainInitPayload): GenerateMagicLinkWithEmailAndPasswordFn {
    const { microservicesSdk } = dependencies;
    return async ({
        email,
        password,
    }: GenerateMagicLinkWithEmailAndPasswordFnPayload) => {
        try {
            const { status, magicLinkId } =
                await microservicesSdk.domains.account.updateStreaming({
                    email,
                    password,
                    generateMagicLink: true,
                });

            /**
             * TODO: Add analytics as needed.
             */

            return {
                status,
                magicLinkId: magicLinkId ?? '',
            };
        } catch (error: any) {
            logErrorFromMicroservicesSdk(error, dependencies);
            throw new Error('SYSTEM');
        }
    };
}
